'use strict';

/**
 * @name flight
 */

exports.gotoAppHomepage = require('./goto-app-homepage.js');

//exports.getUser = require('./get-user.js');
//exports.login = require('./login.js');

exports.getFilter = require('./get-filter.js');
exports.getLinkman = require('./get-linkman.js');
exports.getExpress = require('./get-express.js');
exports.selectCity = require('./select-city.js');
exports.selectDate = require('./select-date.js');
exports.selectRoundDate = require('./select-round-date.js');

//exports.alipay = require('./alipay.js');

exports.gotoOrderDetail = require('./goto-order-detail.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/flight/index.js
// module id = 287
// module chunks = 4